"use strict";

require("core-js/modules/es.array.includes");

require("core-js/modules/es.object.values");

require("core-js/modules/es.string.includes");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateMountPoint = exports.validateFeatureEventType = exports.validateFeatureType = exports.validateFullscriptOptions = void 0;

var _eventType = require("../feature/eventType");

var _featureType = require("../feature/featureType");

var _fullscript = require("../fullscript");

var _staticMessages = require("../staticMessages");

var validateFullscriptOptions = function validateFullscriptOptions(options) {
  if (!_fullscript.FULLSCRIPT_DOMAINS[options.env]) {
    throw new Error(_staticMessages.errorMessage.invalidEnv);
  }
};

exports.validateFullscriptOptions = validateFullscriptOptions;

var validateFeatureType = function validateFeatureType(featureType) {
  if (!Object.values(_featureType.FEATURE_TYPES).includes(featureType)) {
    throw new Error(_staticMessages.errorMessage.invalidFeatureType(featureType));
  }
};

exports.validateFeatureType = validateFeatureType;

var validateFeatureEventType = function validateFeatureEventType(eventType) {
  if (!Object.values(_eventType.EVENT_TYPES).includes(eventType)) {
    throw new Error(_staticMessages.errorMessage.invalidEventType(eventType));
  }
};

exports.validateFeatureEventType = validateFeatureEventType;

var validateMountPoint = function validateMountPoint(element) {
  if (!element) {
    throw new Error(_staticMessages.errorMessage.invalidMountPoint);
  }
};

exports.validateMountPoint = validateMountPoint;